import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { SignupHeader } from '@/components/desktop/auth/signup/SignupHeader';
import { SignupTypeSelector } from '@/components/desktop/auth/signup/SignupTypeSelector';

export function DesktopSignupSelectPage() {
  return (
    <DesktopLayout>
      <div className="min-h-[80vh] flex items-center justify-center py-12">
        <div className="w-full max-w-[600px] bg-white rounded-2xl shadow-lg border border-gray-200 px-12 py-16">
          {/* Header Section */}
          <SignupHeader 
            title="회원가입"
            subtitle="에코딜에서 무엇을 하고 싶으신가요?"
          />
          
          {/* Type Selector Section */}
          <div className="max-w-[400px] mx-auto">
            <SignupTypeSelector />
          </div>
        </div>
      </div>
    </DesktopLayout>
  );
}